import { useEffect, useState } from 'react';
import styles from "./index.module.css";
import BoxContent from './../BoxContent';
import Permutation from './../home/Permutation';
import { useNavigate } from 'react-router-dom';

export default function Permutations(props) {
  const navigate = useNavigate();
  const [permData, setPermData] = useState([]);

  const cancelProject = () => {
    // Logic to delete data or perform other actions if needed
    navigate('/form1');
  };

  useEffect(() => {
    // Retrieve permutations data from local storage
    const storedPermutations = localStorage.getItem('questionFeatures');
    if (storedPermutations) {
      setPermData(JSON.parse(storedPermutations)); // Parse the JSON string into an object
    }
  }, []);

  return (
    <>
    <BoxContent>
    <h3 style={{textAlign: 'center'}}>Options to be evaluated:</h3>
      <div className={styles.permutations}>
        {permData.map((perm) => {
          return (
            <Permutation title={perm.title ?? "title"} price={perm.price ?? "price"} description={perm.description ?? "description"} image={perm.image} />
          )
        })}
      </div>

    </BoxContent>
    <div className={styles["button--container"]}>
      <button onClick={cancelProject}>Cancel</button>
      <button onClick={() => navigate("/form2")}>Next</button>
    </div>
  </>
  );
}
